import { Tag as Chip, TTag as TChip } from './Tag';

Chip.displayName = 'Chip';

export * from './Tag';
export { Chip, TChip };
